"use client";

import { useLanguage } from "@/i18n/LanguageContext";

interface AventuraHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function AventuraHero({ h1, subhead, zips }: AventuraHeroProps) {
  const { t, currentLang } = useLanguage();
  return (
    <section className="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden">
      <img
        src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/2c868764-d8af-4983-acf4-1996385a5b8f_impact-windows-aventura.jpg?v=c4f706cc63e32962014044c86eb99a1a"
        alt={currentLang === "es" ? "Reparación de ventanas en Aventura Miami" : "Window repair in Aventura Miami"}
        className="absolute inset-0 w-full h-full object-cover"
        onError={(e) => {
          (e.target as HTMLImageElement).style.backgroundColor = "#064e3b";
        }}
      />
      <div className="absolute inset-0" style={{ backgroundColor: "rgba(6,78,59,0.7)" }} />
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center py-20">
        <p className="text-[#fbbf24] uppercase tracking-[0.2em] text-sm font-bold mb-6">
          {currentLang === "es" ? "Reparación de Ventanas para Casas en Aventura" : "Window Repair for Aventura Homes"}
        </p>
        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight">
          {h1 || t("aventura.h1")}
        </h1>
        <p className="text-white/90 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          {subhead || t("aventura.subhead")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-8 py-4 text-sm font-bold rounded-[2px] hover:bg-[#c2410c] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {t("hood.callNow")}
          </a>
          <a
            href="/contact/"
            className="inline-flex items-center gap-2 border-2 border-white text-white px-8 py-4 text-sm font-bold rounded-[2px] hover:bg-white hover:text-[#064e3b] transition-colors whitespace-nowrap"
          >
            <i className="ri-calendar-check-line" />
            {t("hood.getQuote")}
          </a>
        </div>
        {zips && zips.length > 0 && (
          <p className="text-white/60 text-sm mt-6 tracking-wide uppercase font-semibold">
            {zips.join(" · ")}
          </p>
        )}
      </div>
    </section>
  );
}